import "../polyfill/dom";
function elementMatches(element, selector = null) {
    return (null === selector || element.matches(selector));
}
function fetchAllSiblings(element, selector, accessor) {
    let indexableElement = element;
    let sibling = indexableElement[accessor];
    const list = [];
    while (sibling) {
        if (elementMatches(sibling, selector)) {
            list.push(sibling);
        }
        sibling = sibling[accessor];
    }
    return list;
}
function fetchSingleSibling(element, selector, accessor) {
    let indexableElement = element;
    let sibling = indexableElement[accessor];
    while (sibling) {
        if (elementMatches(sibling, selector)) {
            return sibling;
        }
        sibling = sibling[accessor];
    }
    return null;
}
export function find(selector, context = document) {
    return Array.prototype.slice.call(context.querySelectorAll(selector));
}
export function findOne(selector, context = document) {
    return context.querySelector(selector);
}
export function filter(list, selector) {
    return list.filter((e) => e.matches(selector));
}
export function not(list, selector) {
    if (typeof selector === "string") {
        return list.filter((e) => !e.matches(selector));
    }
    else if (Array.isArray(selector)) {
        return list.filter((e) => -1 !== selector.indexOf(e));
    }
    return list.filter((e) => e !== selector);
}
export function children(parent, selector = null) {
    const list = [];
    let child = parent.firstElementChild;
    while (child) {
        if (elementMatches(child, selector)) {
            list.push(child);
        }
        child = child.nextElementSibling;
    }
    return list;
}
export function firstChild(parent, selector = null) {
    let child = parent.firstElementChild;
    while (child) {
        if (elementMatches(child, selector)) {
            return child;
        }
        child = child.nextElementSibling;
    }
    return null;
}
export function prev(element, selector = null) {
    return fetchSingleSibling(element, selector, "previousElementSibling");
}
export function next(element, selector = null) {
    return fetchSingleSibling(element, selector, "nextElementSibling");
}
export function prevAll(element, selector = null) {
    return fetchAllSiblings(element, selector, "previousElementSibling");
}
export function nextAll(element, selector = null) {
    return fetchAllSiblings(element, selector, "nextElementSibling");
}
export function siblings(element, selector = null) {
    const list = [];
    let sibling = null;
    if (null !== element.parentElement) {
        sibling = element.parentElement.firstElementChild;
    }
    while (null !== sibling) {
        if (sibling !== element && elementMatches(sibling, selector)) {
            list.push(sibling);
        }
        sibling = sibling.nextElementSibling;
    }
    return list;
}
export function closest(element, selector, rootElement = null) {
    let parent = element.parentElement;
    while (null !== parent && rootElement !== parent) {
        if (parent.matches(selector)) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}
export function isChildElement(parent, node) {
    let pointer = node;
    while (pointer !== null) {
        if (pointer === parent) {
            return true;
        }
        pointer = pointer.parentNode;
    }
    return false;
}
